export enum AuthSourceType {
  LOCAL = 'Local',
  LDAP = 'LDAP',
  OAUTH = 'OAuth',
}
